import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchNyLmiZoneOptionsQuery,
  Flex_FetchNyLmiZoneOptionsQueryVariables,
} from '~/typings/graphql';
import { FETCH_NY_LMI_ZONE_OPTIONS } from './fetch-ny-dac-ez-zone.queries';

export type FetchNyLmiZoneOptionsParams = {
  utilityAccountId: number;
};

export type FetchNyLmiZoneOptionsResponse = {
  dacZone: boolean;
  empowerZone: boolean;
  isAddressPresent: boolean;
};

export const fetchNyLmiZoneOptions = async (
  params: FetchNyLmiZoneOptionsParams,
): Promise<FetchNyLmiZoneOptionsResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchNyLmiZoneOptionsQuery,
    Flex_FetchNyLmiZoneOptionsQueryVariables
  >({
    query: FETCH_NY_LMI_ZONE_OPTIONS,
    variables: {
      utilityAccountId: params.utilityAccountId,
    },
    /**
     * Fetch Policy is set to 'no-cache' because
     * of a slight complication in the resuming mechanism.
     *
     * There are two scenarios in which a user could resume,
     * 1) before giving their enrollment/utility Connect information
     * 2) after the enrollment details have been given.
     *
     * if it's the latter case, the backend has the address of the user
     * and will return the correct NYLmiZoneOptions. However, if it's the
     * former case, when resuming, the backend will not have the address
     * of the user and will return false for NYLmiZoneOptions.
     *
     * The problem is, we just made a network call while resuming, if we
     * immediately make another call to backend after we got the address in
     * enrollment step, Apollo will return the cached response from the
     * previous call. So we need to make sure that we are not using the cached
     * response and always make a network call.
     *
     * This is not a very frequent call so its okay if we don't use the cached
     * response.
     * TODO: find out a better way to do this.
     *
     */
    fetchPolicy: 'no-cache',
  });

  return {
    dacZone: !!data.utilityAccount.nyLmiZoneOptions?.dacZone,
    empowerZone: !!data.utilityAccount.nyLmiZoneOptions?.empowerZone,
    isAddressPresent: !!data.utilityAccount.nyLmiZoneOptions?.isAddressPresent,
  };
};
